var map = {
	"./feature_buy_bonus_cn.png": 95534,
	"./feature_buy_bonus_en.png": 47448,
	"./feature_buy_bonus_id.png": 52630,
	"./feature_buy_bonus_ko.png": 29647,
	"./feature_buy_bonus_ph.png": 97853,
	"./feature_buy_bonus_th.png": 91894,
	"./feature_buy_bonus_zh.png": 54571,
	"./feature_buy_cn.png": 77514,
	"./feature_buy_en.png": 1356,
	"./feature_buy_freespin_cn.png": 1307,
	"./feature_buy_freespin_en.png": 5657,
	"./feature_buy_freespin_id.png": 17831,
	"./feature_buy_freespin_ko.png": 48906,
	"./feature_buy_freespin_ph.png": 47880,
	"./feature_buy_freespin_th.png": 59380,
	"./feature_buy_freespin_zh.png": 73706,
	"./feature_buy_id.png": 56098,
	"./feature_buy_ko.png": 29915,
	"./feature_buy_ph.png": 302,
	"./feature_buy_th.png": 66933,
	"./feature_buy_zh.png": 26015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66038;